var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"minimal-layout"},[_c('div',{attrs:{"id":"viewport"}},[_c('OHeaderMinimal'),_vm._v(" "),_vm._t("default"),_vm._v(" "),_c('OFooter')],2)])}
var staticRenderFns = []

export { render, staticRenderFns }